import axios from "axios";

export default class HttpRequests{

    login(code,password){

        return axios.post('/login',{code,password})

    }

    loginWithToken(){

        return axios.get('/loginWithToken')
    }

    getPositions(){
        return axios.get('/getPositions')
    }

    citizenship(){
        return axios.get('/citizenship')
    }

    savePerson(formData){

        return axios.post('/savePerson',formData)
    }

    programtype(){
        return axios.get('/programtype')
    }
    saveprogram(programname,program_typeID,Programfee){
        return axios.post('/saveprogram',{programname,program_typeID,Programfee})
    }

 savemodule(module_name){
    return axios.post('/module',{module_name})
 }

 getModule(){
    return axios.get('/getModule')
 }

 editModule(moduleID,module_name,description){

    return axios.post('/editModule',{moduleID,module_name,description})

 }

 getPrograms(){
    return axios.get('/getPrograms')
 }

 saveprogrammodule(moduleIDs,programID){

    return axios.post('/saveprogrammodule',{moduleIDs,programID})

 }

 removeModule(program_moduleID){
    return axios.post('/removeModule',{program_moduleID})
 }

 saveStudent(formData){
    return axios.post('/saveStudent',formData)
 }

 editStudent(formData){
   return axios.post('/editStudent',formData)
}

editPerson(formData){
   return axios.post('/editPerson',formData)
}

 
  

 saveOrder(formData){

    return axios.post('/saveOrder',formData)

 }

 getOrdersYears(){
   return axios.get('/getOrdersYears')
 }

 getOrder(year){
    return axios.get('/getOrder?year='+year)
 }

 goEditOrder(formData){
    return axios.post('/goEditOrder',formData)
 }

 deleteOrder(orderID){

    return axios.post('/deleteOrder',{orderID})
 }

 saveExternalCorrespondence(formData){

    return axios.post('/saveExternalCorrespondence',formData)

 }


 getExternalCorrespondenceYears(){
   return axios.get('/getExternalCorrespondenceYears')
 }

 getExternalCorrespondence(year){
    return axios.get('/getExternalCorrespondence?year='+year)
 }

 goEditExternalCorrespondence(formData){

    return axios.post('/goEditExternalCorrespondence',formData)

 }

 deleteCorrespondence(external_correspondenceID){

    return axios.post('/deleteCorrespondence',{external_correspondenceID})

 }
 savecorr(formData){
   return axios.post('/saveinternalcorrespondence',formData)
 }

 getInternalCorrespondenceYears(){
   return axios.get('/getInternalCorrespondenceYears')
 }
 getinternalCorrespondence(year){
   return axios.get('/getinternalCorrespondence?year='+year)
 }
 goEditinternalCorrespondence(formData){
   return axios.post('/goEditinternalCorrespondence',formData)
 }

 
 deleteinternalCorrespondence(internalcorrespondenceID){

   return axios.post('/deleteinternalCorrespondence',{internalcorrespondenceID})

}
saveacademiccouncil(formData){

   return axios.post('/saveacademiccouncil',formData)

}


getAcademicCouncilYears(){
   return axios.get('/getAcademicCouncilYears')
}

getAcademiccouncil(year){
   return axios.get('/getAcademiccouncil?year='+year)
}



goEditacademiccouncil(formData){
   return axios.post('/goEditacademiccouncil',formData)
}
deleteCouncil(academicCouncilID){

   return axios.post('/deleteCouncil',{academicCouncilID})

}

getstudent(){
return axios.get('/getstudent')
}

getperson(){
   return axios.get('/getperson')
}
getDays(){
   return axios.get('/getDays')
}

savegroup(moduleID,personID,start_date,finish_date,lecture_start,lecture_end,programID){
   return axios.post('/savegroup',{moduleID,personID,start_date,finish_date,lecture_start,lecture_end,programID})
}

getGroups(){
   return axios.get('/getGroups')
}

deleteGroupRow(groupID){

   return axios.post('/deleteGroupRow',{groupID})

}

addmoreDayAndTime(groupID,lecture_start,lecture_end){

      return axios.post('/addmoreDayAndTime',{groupID,lecture_start,lecture_end})
}

saveStudents(groupN,chosenStudents){

   return axios.post('/saveStudents',{groupN,chosenStudents})

}

getStudentsInGroup(groupN){

   return axios.get('/getStudentsInGroup/'+groupN)

}

deleteStudentFromGroup(groupN,studentID){

   return axios.post('/deleteStudentFromGroup',{groupN,studentID})

}

getLecturerGroups(){
   return axios.get('/getLecturerGroups')
}

saveAbscence(come,leaved){

   return axios.post('/saveAbscence',{come,leaved})

}

showStudentsAbscences(groupN){

   return axios.get('/showStudentsAbscences/'+groupN)

}
saveevaluation(evaluation_type,registrationID){
   return axios.post('/saveevaluation',{evaluation_type,registrationID})
}


getStaffList(){

   return axios.get('/getperson')


}

getStudentsList(){
   return axios.get('/getstudent')
}

getReasons(){
   return axios.get('/getReasons')
}

addStatus(reasonID,orderNum,order_date,chosenStudent,programID,start_date,end_date){

   return axios.post('/addStatus',{reasonID,orderNum,order_date,chosenStudent,programID,start_date,end_date})

}


getStudentsStatuses(studentID){

   return axios.post('/getStudentsStatuses',{studentID})

}

deleteStatus(statusID){

   return axios.post('/deleteStatus',{statusID})

}

logOut(){

   return axios.post('/logOut')
}


getStudentInfo(studentID){

   return axios.get('/getStudentInfo/'+studentID)

}

getStuffInfo(personID){

   return axios.get('/getStuffInfo/'+personID)

}


 


deleteStudent(studentID){

   return axios.post('/deleteStudent',{studentID})

}

deleteStaff(personID){

   return axios.post('/deleteStaff',{personID})

}
saveAnotherStartEnd(chosenGroupN,start_date,finish_date,lecture_start,lecture_end){

return axios.post('/saveAnotherStartEnd',{chosenGroupN,start_date,finish_date,lecture_start,lecture_end})

}

getGroupsDetailed(groupN){

   return axios.get('/getGroupsDetailed/'+groupN)


}


updateProgramID(groupN,programID){

   return axios.post('/updateProgramID',{groupN,programID})

}

getJournalInfo(programID){

   return axios.post('/getJournalInfo',{programID})

}

saveJournalComment(groupN,comment){

   return axios.post('/saveJournalComment',{groupN,comment})

}


getMyApplications(statusID,condition){

      return axios.post('/getStudentApplications',{statusID,condition})


}


setStatusToCorrespondence(correspondenceID,statusID){
   return axios.post('/setStatusToCorrespondence',{correspondenceID,statusID})
}


setResolution(correspondenceID,resolution){

   return axios.post('/setResolution',{correspondenceID,resolution})
}

forwardCorrespondence(correspondenceID,personID){

   return axios.post('/forwardCorrespondence',{correspondenceID,personID})

}

updateSheetPrintStatus(groupN,status){

   return axios.post('/updateSheetPrintStatus',{groupN,status})

}


}